// Two-tier muscle taxonomy backing the exercise picker/creation UI.
// MUSCLE_GROUPS is the fixed top-level category list (what an exercise doc's
// `targetMuscle` field holds); MUSCLE_TAXONOMY maps each group to its allowed
// main-muscle sub-categories (what `mainMuscle` holds). Both are fixed lists
// -- the muscle group AND main muscle for a new/edited exercise are always
// picked from here, never freehand text. Derived from the user-supplied
// weight_training_exercises.md reference, with a few compound "X/Y" values
// from that source collapsed to a single representative muscle so this stays
// a clean pickable list rather than carrying forward "primary muscle A or B"
// ambiguity into the taxonomy itself.
export const MUSCLE_TAXONOMY = {
  Chest: ["Pectoralis Major", "Upper Pectoralis Major", "Lower Pectoralis Major"],
  Back: ["Erector Spinae", "Latissimus Dorsi", "Rhomboids", "Trapezius", "Rear Deltoids"],
  Shoulders: ["Deltoids", "Lateral Deltoid", "Anterior Deltoid", "Posterior Deltoid"],
  Arms: ["Biceps Brachii", "Brachialis", "Triceps Brachii", "Wrist Flexors", "Wrist Extensors", "Forearm Flexors"],
  Legs: ["Quadriceps", "Hamstrings", "Glutes", "Gastrocnemius", "Soleus"],
  Core: ["Rectus Abdominis", "Lower Rectus Abdominis", "Obliques"],
  // Cardio sits at the same level as the body-part groups above (it's a
  // `targetMuscle` value, same as "Chest"/"Legs"/etc.), but has no main-
  // muscle sub-taxonomy that makes sense -- left as an empty array rather
  // than omitted entirely, so every spot that does `MUSCLE_TAXONOMY[group]
  // .map(...)` (the Main Muscle dropdown, RoutinePicker's builder) degrades
  // gracefully to "no sub-options" instead of needing a special case; main
  // muscle is already optional app-wide (2026-08-21), so an empty dropdown
  // here is a non-issue. What actually distinguishes a Cardio exercise is
  // its logged-field shape (duration/distance instead of weight/reps) --
  // see CARDIO_GROUP/isCardioExercise below, which is the single signal the
  // rest of the app branches on.
  Cardio: []
};

export const MUSCLE_GROUPS = Object.keys(MUSCLE_TAXONOMY);

// The one signal the app uses to decide whether an exercise logs
// weight/reps (strength) or hours/minutes/distance (cardio) -- anywhere
// that needs to branch checks `targetMuscle === CARDIO_GROUP` via this
// helper, rather than re-deriving the string literal at each call site.
export const CARDIO_GROUP = "Cardio";
export const isCardioExercise = (exercise) => exercise?.targetMuscle === CARDIO_GROUP;
